import { Factory } from '@infodata-group/inf-commons';
import { BackOfficeVigiMenuItemInterface } from '../interface/back-office/back-office-vigi-menu-item.interface';
import { VigiMenuItem } from '../model/vigi-menu-item';
import { CrudAuthorization } from '../modules/shared/model/generic-page/crud-authorization';
import { Layout } from '../modules/shared/model/generic-page/layout';

export class FactoryVigiMenuItem implements Factory<VigiMenuItem> {
  build(o: BackOfficeVigiMenuItemInterface): VigiMenuItem {
    const menuItem = new VigiMenuItem(o.id, o.label, o.icon, o.route);
    menuItem.disabled = o.disabled !== undefined ? o.disabled : false;

    if (o.CRUD) {
      menuItem.CRUD = new CrudAuthorization();
      menuItem.CRUD.creation = o.CRUD.creation;
      menuItem.CRUD.read = o.CRUD.read;
      menuItem.CRUD.update = o.CRUD.update;
      menuItem.CRUD.delete = o.CRUD.delete;
    }

    if (o.layout) {
      menuItem.layout = new Layout(o.layout.endPoint);
      menuItem.layout.container = o.layout.container;
      menuItem.layout.pagination = o.layout.pagination;
      menuItem.layout.urlGdx = o.layout.urlGdx;
      menuItem.layout.directSearch = o.layout.directSearch;
      menuItem.layout.directEdit = o.layout.directEdit;
    }

    if (o.layout && o.layout.exportGroups) {
      menuItem.layout.exportGroups = o.layout.exportGroups;
    }

    if (o.childrens) {
      menuItem.submenus = o.childrens.map((item) => {
        const child = this.build(item);
        child.icon = '';
        child.parentId = menuItem.id;
        return child;
      });
    }
    return menuItem;
  }

  getApi(): string {
    return '';
  }
}
